import { gql } from '@/utilities/gql';

export const NARRATIVE_FRAGMENT = gql(`
  fragment NarrativeFields on Narrative @_unmask {
    isFeatured
    companyId
    contentBlocks {
      contentHtml
      id
      title
    }
    id
    slug
    title
    valuation {
      discountRate
      fairValue
      futurePePercentageChange
      futureSharesOutstanding
      profitMarginPercentageChange
      revenuePercentageChange
      timeframe
      fiscalData {
        mostRecentReportedDate
        yearlyTimeSeries {
          year
          data {
            netIncome
            revenue
            endDate
          }
        }
      }
    }
    voteCount {
      downvotes
      upvotes
    }
    announcements {
      contentHtml
      createdAt
      id
    }
    userHoldsPosition
    coverImageUrl
    createdAt
    updatedAt
    type
    author {
      displayName
      id
      imageUrl
      name
      role
      slug
      url
      isExternal
    }
  }
`);
